export default {
  mounted (el: any, binding: any) {
    const node = document.createElement('div')
    const nodeChild = document.createElement('div')
    nodeChild.classList.add('hts-loading__dot-fire')
    node.classList.add('hts-loading')
    node.appendChild(nodeChild)
    el.setAttribute('data-position', el.style.position)
    el.setAttribute('data-overflow', el.style.overflow)
    el.style.position = 'relative'
    el.style.overflow = 'hidden'
    el.appendChild(node)

    if (binding.value) {
      node.classList.add('is-loading')
    }
  },
  updated (el: any, binding: any) {
    const loadingEl = el.querySelector('.hts-loading')
    if (binding.value) {
      el.setAttribute('data-position', el.style.position)
      el.setAttribute('data-overflow', el.style.overflow)
      el.style.position = 'relative'
      el.style.overflow = 'hidden'
      if (loadingEl && !loadingEl.classList.contains('is-loading')) {
        loadingEl.classList.add('is-loading')
      }
    } else {
      el.style.position = el.getAttribute('data-position')
      el.style.overflow = el.getAttribute('data-overflow')
      if (loadingEl && loadingEl.classList.contains('is-loading')) {
        loadingEl.classList.remove('is-loading')
      }
    }
  },
  getSSRProps () {
    return {}
  }
}
